import { GQL } from "@binale-tech/shared";

type YearConfig = Pick<GQL.ICompanyAccountingYear, "taxation" | "ustvaFrequency"> | null | undefined;

/** The UStVA cadence of a year, null when it is unknown or none is due; a config without frequency counts as monthly like the UStVA page. */
export const resolveUstvaFrequency = (config: YearConfig): GQL.IUstvaFilingFrequency | null => {
    if (!config || config.taxation === GQL.ICompanyTaxation.Kust) return null;
    return config.ustvaFrequency ?? GQL.IUstvaFilingFrequency.Monthly;
};
